import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import api from "../api/api";
import { useAuth } from "../features/auth/AuthContext";
import LinearWithValueLabel from "../utils/LinearProgresslabel";
import MyCourses from "../pages/home/components/dashboard/teacher/Tab/MyCourses";
import { updateGlobalState } from "../state/global/slice";
import Card from "../pages/home/components/dashboard/teacher/course/Card";
import {
  alert_image,
  graduation,
  Teacher_Dashboard_Default,
    Teacher_Dashboard_Default_NEW,
  dashborad_Courses_book_image,
  Asset_teacher,
  Asset_teacher2,
  warning_blue_img,
} from "../assets/images/images";
import { toast } from "react-toastify";
import BackButton from "./BackButton/BackButton";
import { getAllCoursesByTeacherId } from "../state/actions/getAllCoursesByTeacherIdAction";
import { getAllArchivedCoursesAction } from "../state/actions/getAllArchivedCoursesAction";
import FloatingAIButton from "./FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../state/reducers/chatDrawerReducers";
import { isArguments } from "lodash";
import ArchiveCourses from "../pages/home/components/dashboard/teacher/Tab/ArchiveCourses";
import { fetchCourseDetails } from "../state/actions/getEnrolledCoursesDataAction";
import Loader from "./FileRepo/Components/Loader";

const TeacherCourseList = () => {
  const navigate = useNavigate();
  const { token } = useAuth();
  const itemsPerPage = 12;
  const [selLession, setSelLession] = useState(-1);

  const [nextUrl, setNextUrl] = useState(null);
  const location = useLocation();
  const [totalPages, setTotalPages] = useState(location?.state?.totalPages ?? 0);
  const [prevUrl, setPrevUrl] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("active");
  const [coursesData, setCoursesData] = useState([]);
const [archiveCurrentPage, setArchiveCurrentPage] = useState(1);
const [archiveTotalPages, setArchiveTotalPages] = useState(0);
const [archiveNextUrl, setArchiveNextUrl] = useState(null);
const [archivePrevUrl, setArchivePrevUrl] = useState(null);
const [pendingArchives, setPendingArchives] = useState({});

  const onExpand = (i) => {
    setSelLession(selLession === i ? -1 : i);
  };
  const [lessonsDtls, setLessonsDtls] = useState();
  const inial_value = (currentPage - 1) * itemsPerPage;
  const [deleteCourse, setdeleteCourse] = useState(false);
  const [archiveCourse, setArchiveCourse] = useState(false);
  const [archiveLoading, setArchiveLoading] = useState(false);
  const [archiveAction, setArchiveAction] = useState({courseId: null, isArchived: false});
  const [activeCoursesCount, setActiveCoursesCount] = useState(0);
  const [archivedCoursesCount, setArchivedCoursesCount] = useState(0);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const [loading, setLoading] = useState(false);
  const globalState = useSelector((state) => state.globalState);
  const dispatch = useDispatch();
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };

  const toggleDeleteCourse = () => {
    setdeleteCourse(!deleteCourse);
    setLoading(false);
    document.body.style.overflow = "auto";
  };

   const closeArchiveModal = () => {
  setArchiveCourse(false);
  setArchiveLoading(false);
  document.body.style.overflow = "auto";
};
  
  const teacher_id = globalState?.teacher_details?.data?.teacher_id;
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }
  const [selectedCourse, setSelectedCourse] = useState(null);

const undoArchive = (courseId) => {
  const pending = pendingArchives[courseId];

  if (!pending) return;

  clearTimeout(pending.timeoutId);

  setPendingArchives((prev) => {
    const updated = { ...prev };
    delete updated[courseId];
    return updated;
  });

  toast.success("Archive cancelled");
};
const toggleArchiveCourse = (course) => {
  setArchiveAction({
    courseId: course.course_id,
    isArchived: course.is_archived,
  });

  setSelectedCourse(course.name);

  setArchiveCourse(true);
  setArchiveLoading(false);

  document.body.style.overflow = "hidden";
};
const executeArchive = async (course) => {
  const courseId = course.course_id;

  try {
    const response = await api.post(
      `/courses/${courseId}/archive/`,
      {
        is_archived: !course.is_archived,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      },
    );

    if (response.status === 200) {
      dispatch(getAllCoursesByTeacherId(currentPage, teacher_id, token));
      dispatch(
        getAllArchivedCoursesAction(archiveCurrentPage, teacher_id, token),
      );
      fetchCourseCount()
      toast.success(
        <div>
          <div className="font-bold">
            {course.is_archived
              ? "Course Restored Successfully"
              : "Course Archived Successfully"}
          </div>

          <div className="mt-1">
            {course.is_archived ? (
              <>“{course.name}” has been moved back to Active Courses</>
            ) : (
              <>
                You can access the archived course, “{course.name},” from the
                Total Courses → Archive tab.
              </>
            )}
          </div>
        </div>,
        {
          containerId: "archive-toast",
        },
      );
    } else {
      toast.error("Something went wrong. Please Try Again", {
        position: "top-center",
      });
    }
  } catch (error) {
    toast.error("Something went wrong.", {
      position: "top-center",
    });
  }

  setPendingArchives((prev) => {
    const updated = { ...prev };
    delete updated[courseId];
    return updated;
  });
};
  const fetchCourseCount= async ()=>{
    try {
      const response = await api
          .get("/auth/teacher-dashboard-count/", {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          })
      setActiveCoursesCount(response.data.data.active_courses)
      setArchivedCoursesCount(response.data.data.archived_courses)
    } catch (error) {
      toast.error("Failed to Load Course Count ")
    }
  }
  const deleteCourseId = async () => {
    setLoading(true);
    document.body.style.overflow = "auto";
    try {

      const response = await api.delete(
        `/courses/delete-course/${selectedCourse}/`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setLoading(false);
        const course_list = globalState.course_list?.filter(
          (course) => course.course_id !== selectedCourse
        );
        updateState("course_list", course_list);
        if (activeTab === "active") {
          dispatch(getAllCoursesByTeacherId("1", teacher_id, token));
        } else {
          dispatch(
            getAllArchivedCoursesAction(archiveCurrentPage, teacher_id, token),
          );
        }
        await fetchCourseCount()
        toast.success("Course deleted successfully.", {
          position: "top-center",
        });
        setTimeout(() => {
          setdeleteCourse(false);
        }, 700);
      } else {
        setLoading(false);
        setdeleteCourse(false);
        toast.error("Something went wrong.", {
          position: "top-center",
        });
      }
    } catch (error) {
      setLoading(false);
      setdeleteCourse(false);
    }
  };

  const handleArchiveCourse = async () => {
  const { courseId } = archiveAction;

  if (!courseId) return;

 const course =
  myCourses?.find((c) => c.course_id === courseId) ||
  archiveCourses?.find((c) => c.course_id === courseId);

  if (!course) return;

  setArchiveCourse(false);
  document.body.style.overflow = "auto";

  if (course.is_archived) {
  await executeArchive(course);
  return;
}

const expiresAt = Date.now() + 5000;

const timeoutId = setTimeout(async () => {
  await executeArchive(course);
}, 5000);

setPendingArchives((prev) => ({
  ...prev,
  [courseId]: {
    timeoutId,
    expiresAt,
  },
}));
};

 useEffect(() => {
  const handleVisibilityChange = async () => {
    if (document.hidden) {
      const pendingEntries = Object.entries(pendingArchives);

      for (const [courseId, value] of pendingEntries) {
        clearTimeout(value.timeoutId);

       const course =
         myCourses?.find((c) => c.course_id === courseId) ||
         archiveCourses?.find((c) => c.course_id === courseId);

       if (!course) return;

        if (course) {
          await executeArchive(course);
        }
      }
    }
  };

  document.addEventListener(
    "visibilitychange",
    handleVisibilityChange
  );

  return () => {
    document.removeEventListener(
      "visibilitychange",
      handleVisibilityChange
    );
  };
}, [pendingArchives, globalState.course_list]);

  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };

  useEffect(()=>{
    return(() => {
      dispatch(setDrawerState(false));
    });
  },[])

  useEffect(()=>{
    fetchCourseCount()
  },[token])

useEffect(() => {
  if (!teacher_id || !token) return;

  if (activeTab === "active") {
    dispatch(
      getAllCoursesByTeacherId(currentPage, teacher_id, token)
    );
  }
}, [activeTab, currentPage, teacher_id, token, dispatch]);

useEffect(() => {
  if (!teacher_id || !token) return;

  if (activeTab === "archived") {
    dispatch(
      getAllArchivedCoursesAction(
        archiveCurrentPage,
        teacher_id,
        token
      )
    );
  }
}, [activeTab, archiveCurrentPage, teacher_id, token, dispatch]);

const archivePagination = useSelector(
  (state) => state.archiveCourseList
);

useEffect(() => {
  if (archivePagination) {
    setArchiveTotalPages(archivePagination.totalPages || 0);
    setArchiveNextUrl(archivePagination.next || null);
    setArchivePrevUrl(archivePagination.previous || null);
  }
}, [archivePagination]);

const handleArchivePageChange = (event, value) => {
  window.scrollTo(0, 0);
  setArchiveCurrentPage(value);
};

 const myCourses = useSelector((state) => state.getallCoursesByTeacherId.courses);
 const archiveCourses = useSelector(
     (state) => state?.archiveCourseList?.courses || [],
   );

  return (
    <>
      <div id="CourseList-section">
        <div className="CourseList-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-md-12">
                <div className="view-course-Details-back-btn-folder">
                  <BackButton  fallbackPath={"/dashboard/home"} buttonName={"Back"} />
                </div>
                <h3 className="text-lg">Courses</h3>
                <div className="view-lessons-section">
                  <div className="view-lessons-wrapper">
                    <div className="view-lessons-btn-container StudentCourseCard-lessons-tab-container !justify-start">
                      <button
                        className={`tab-button ${
                          activeTab === "active" ? "active" : ""
                        }`}
                        onClick={() => {
                          setCurrentPage(1);
                          setActiveTab("active");
                        }}
                      >
                        Active Courses ({activeCoursesCount || 0})
                      </button>

                      <button
                        className={`tab-button ${
                          activeTab === "archived" ? "active" : ""
                        }`}
                        onClick={() => {
                          setArchiveCurrentPage(1);
                          setActiveTab("archived");
                        }}
                      >
                        Archived Courses ({archivedCoursesCount || 0})
                      </button>
                    </div>
                  </div>
                </div>
                <div className="created-my-courses-wrapper">
                  {globalState?.course_list === null ||
                  globalState?.course_list?.length === 0 ? (
                    <>
                      <Card
                        image={Teacher_Dashboard_Default_NEW}
                        title="Craft an Interactive Course"
                        description="Crafting an interactive course involves designing engaging lessons with quizzes and activities to actively involve students in the learning process"
                      />
                      <Card
                        image={Teacher_Dashboard_Default}
                        title="Build an Exciting Learning Journey"
                        description="Crafting an exciting learning journey involves designing engaging educational experiences that captivate students and ignite their curiosity"
                      />
                    </>
                  ) : activeTab === "active" ? (
                    <MyCourses
                      courses={myCourses}
                      totalPages={totalPages}
                      currentPage={currentPage}
                      nextUrl={nextUrl}
                      prevUrl={prevUrl}
                      handlePageChange={handlePageChange}
                      setSelectedCourse={setSelectedCourse}
                      closeModal={closeModal}
                      modalIsOpen={modalIsOpen}
                      openModal={openModal}
                      toggleDeleteCourse={toggleDeleteCourse}
                      toggleArchiveCourse={toggleArchiveCourse}
                      pendingArchives={pendingArchives}
                      undoArchive={undoArchive}
                    />
                  ) : (
                    <ArchiveCourses
                      courses={archiveCourses}
                      toggleDeleteCourse={toggleDeleteCourse}
                      toggleArchiveCourse={toggleArchiveCourse}
                      setSelectedCourse={setSelectedCourse}
                      nextUrl={archiveNextUrl}
                      prevUrl={archivePrevUrl}
                      handlePageChange={handleArchivePageChange}
                      totalPages={archiveTotalPages}
                      currentPage={archiveCurrentPage}
                    />
                  )}
                </div>
                <FloatingAIButton
                  onClick={() => {
                    dispatch(setDrawerState(!chatDrawerState.isOpen));
                    dispatch(setIsWebAllowed(true));
                    dispatch(setQueryMetaData(null));
                  }}
                />

                {deleteCourse && (
                  <form action="" className="delete-course-form">
                    <div
                      className="delete-course-form-container"
                      data-aos="zoom-in"
                    >
                      <div className="delete-course-alert-image">
                        <img src={alert_image} alt="" />
                      </div>
                      <h2>Are you sure you want to delete this course?</h2>
                      <div className="delete-course-form-btn-folder">
                        <button
                          type="button"
                          onClick={toggleDeleteCourse}
                          className="not-delete-btn"
                        >
                          No
                        </button>
                        {loading ? (
                          <div className="loading-spinner" />
                        ) : (
                          <button
                            type="button"
                            onClick={deleteCourseId}
                            disabled={loading}
                            className="delete-btn"
                          >
                            Delete
                          </button>
                        )}
                      </div>
                    </div>
                  </form>
                )}
                {archiveCourse && (
                  <form action="" className="delete-course-form">
                    <div
                      className="delete-course-form-container relative"
                      data-aos="zoom-in"
                    >
                      {archiveLoading && (
                        <div className="absolute inset-0 z-50 flex items-center justify-center bg-white rounded-xl">
                          <Loader />
                        </div>
                      )}

                      <div className="delete-course-alert-image">
                        <img src={warning_blue_img} alt="" />
                      </div>

                      <h2>
                        Are you sure you want to{" "}
                        {archiveAction.isArchived ? "unarchive" : "archive"}{" "}
                        this course?
                      </h2>

                      <div className="delete-course-form-btn-folder">
                        <button
                          type="button"
                          onClick={closeArchiveModal}
                          disabled={archiveLoading}
                          className="border-[#0068FF] bg-white text-[#0068FF]"
                        >
                          No
                        </button>

                        <button
                          type="button"
                          onClick={handleArchiveCourse}
                          disabled={archiveLoading}
                          className="border-[#0068FF] text-white bg-[#0068FF]"
                        >
                          {archiveAction.isArchived ? "Unarchive" : "Archive"}
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherCourseList;
